<script lang="ts">
	import PressBannerItem from '$lib/pressBanner/pressBannerItem.svelte';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import type { SbImage } from '../types';

	interface Props {
		content: ISbStoryData<{
			logo: SbImage;
			text: ISbRichtext;
		}>['content'];
		active?: number;
		index?: number;
		color?: 'stone-5' | 'brown-2';
		onclick?: () => void;
	}

	let { content, active = 0, index = 0, color = 'stone-5', onclick }: Props = $props();
</script>

<PressBannerItem active={active === index} {onclick} class="text-{color}">
	{#snippet image()}
		<img
			loading="lazy"
			class="h-full w-full object-contain"
			src={content.logo.filename}
			alt={content.logo.alt}
			height={28}
		/>
	{/snippet}
	<SbRichtext text={content.text} />
</PressBannerItem>
